import { HttpInterceptorFn } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { inject, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError, Observable } from 'rxjs';
import Swal from 'sweetalert2';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const ngZone = inject(NgZone);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const errorMessage = error.error?.message || 'Something went wrong!';
      const errorCode = error.status || 500;
      const errorStatus = error.statusText || 'Error';

      if (errorCode === 401) {
        Swal.fire({
          title: 'Unauthorized!',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'OK',
        }).then(() => {
          ngZone.run(() => {
            localStorage.removeItem('auth_key');
            router.navigate(['/cms/login']);
          });
        });

        return new Observable<never>();
      }

      Swal.fire({
        title: `Ooops :(, ${errorCode}`,
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'OK',
      });

      return throwError(() => error);
    })
  );
};
